<template>
	<div data-tour-scope="email-templates">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ $vuetify.lang.t('$vuetify.front.ecommerce.emailtemplate') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn elevation="0" text title="Aggiungi template" data-tour="add" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>


						<v-data-table
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							data-tour="table"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="emailtpl-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="(item.trans && item.trans.oggetto) || 'Template'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-btn small icon color="primary" data-tour="expand" :title="aperto(item) ? 'Chiudi' : 'Anteprima e lingue'" @click="apri(item)">
														<v-icon>{{ aperto(item) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-edit" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-slot:top>
													<div class="d-flex align-center flex-wrap mb-1">
														<v-icon small color="primary" class="mr-1">{{ tipo(item).icona }}</v-icon>
														<span class="font-weight-medium mr-2">{{ tipo(item).label }}</span>
														<v-chip v-if="item.status && item.status.value" x-small label outlined color="primary">{{ item.status.value }}</v-chip>
													</div>
													<div class="et-flags mb-1">
														<img
															v-for="l in statoLingue(item)"
															:key="l.lang"
															:src="bandiera(l.lang)"
															:alt="l.lang"
															:class="{ 'et-flag--off': !l.ok }"
															:title="l.lang.toUpperCase() + (l.ok ? ' compilata' : ' da completare')"
														/>
													</div>
												</template>
												<EmailTemplateDetail v-if="aperto(item)" :item="item" :lingue="lingue" @edit="editItem(item)" @delete="deleteItem(item)" />
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="item in items">
										<tr :key="item._id">
											<td class="pl-1 pr-0 text-no-wrap" style="width: 76px">
												<v-menu top eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
															<v-icon>mdi-dots-vertical</v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item link data-tour="row-edit" @click="editItem(item)">
															<v-list-item-title class="size9">Modifica</v-list-item-title>
														</v-list-item>
														<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
															<v-list-item-title class="size9">Elimina</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
												<v-btn small icon color="primary" data-tour="expand" :title="aperto(item) ? 'Chiudi' : 'Anteprima e lingue'" @click="apri(item)">
													<v-icon>{{ aperto(item) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td>
												<div class="d-flex align-center">
													<v-icon small color="primary" class="mr-2">{{ tipo(item).icona }}</v-icon>
													<span class="font-weight-medium">{{ tipo(item).label }}</span>
												</div>
											</td>
											<td>
												<v-chip v-if="item.status && item.status.value" x-small label outlined color="primary">{{ item.status.value }}</v-chip>
											</td>
											<td class="et-subject text-left">{{ item.trans && item.trans.oggetto }}</td>
											<td data-tour="langs">
												<div class="et-flags">
													<img
														v-for="l in statoLingue(item)"
														:key="l.lang"
														:src="bandiera(l.lang)"
														:alt="l.lang"
														:class="{ 'et-flag--off': !l.ok }"
														:title="l.lang.toUpperCase() + (l.ok ? ' compilata' : ' da completare')"
													/>
												</div>
											</td>
											<td class="text-no-wrap">{{ item.updated_at | moment('DD/MM/YYYY') }}</td>
											<td class="text-no-wrap">{{ item.created_at | moment('DD/MM/YYYY') }}</td>
										</tr>
										<tr v-if="aperto(item)" :key="item._id + '-detail'" class="et-expanded">
											<td :colspan="headers.length" class="py-3">
												<EmailTemplateDetail :item="item" :lingue="lingue" @edit="editItem(item)" @delete="deleteItem(item)" />
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" multi-line :timeout="snackbar.timeout">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando il template non potrai più ripristinarlo e per il suo evento il sito smetterà di mandare l'email.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="error" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createEmailTemplatesTourSteps, stopEmailTemplatesTour } from './email-templates-tour';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import EmailTemplateDetail from '@/components/ecommerce/emailtemplate/EmailTemplateDetail.vue';
import { tipologia, testoPiano, bandiera } from '@/components/ecommerce/emailtemplate/tipologie';
import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'EmailTemplates',
	// pagina, righe e ordinamento stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createEmailTemplatesTourSteps(), { onStop: stopEmailTemplatesTour }) };
	},
	components: {
		TourOverlay,
		KeyValueCard,
		EmailTemplateDetail,
	},
	data() {
		return {
			snackbar: { snackbar: false, color: '', timeout: 5000, text: '' },
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {},
				options: { sortBy: ['created_at'], sortDesc: [true], page: 1, itemsPerPage: 15 },
			}),
			listSize: LIST_SIZE,
			total: 0,
			headers: [
				// colonna del menu a tre puntini e del dettaglio: non si ordina
				{ text: '', value: '', sortable: false },
				{ text: 'Tipologia', value: 'type' },
				{ text: 'Evento', value: 'status.value' },
				{ text: 'Oggetto', value: 'trans.oggetto' },
				{ text: 'Lingue', value: 'lingue', sortable: false },
				{ text: 'Aggiornato', value: 'updated_at' },
				{ text: 'Creato', value: 'created_at' },
			],
			// template con il dettaglio aperto (+)
			aperti: [],
			dialogconfirm: false,
			daEliminare: null,
		};
	},
	created() {
		this.listLoad();
		this.fetchSetting();
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// lingue del profilo, la predefinita per prima
		lingue() {
			const lingue = (this.getSettings && this.getSettings.languages) || [];
			return _.sortBy(lingue, l => (l.default ? 0 : 1)).map(l => l.lang);
		},
		...mapGetters({
			getItems: 'emailtemplate/getItems',
			getSettings: 'settings/getSetting',
		}),
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			fetchItems: 'emailtemplate/asyncFetchData',
			destroyData: 'emailtemplate/destroyData',
			delete: 'emailtemplate/deleteItem',
			fetchSetting: 'settings/asyncFetchData',
		}),
		// coppie chiave/valore della card su telefono
		campiCard(item) {
			return [
				{ label: 'Aggiornato', value: item.updated_at ? this.$moment(item.updated_at).format('DD/MM/YYYY') : '' },
				{ label: 'Creato', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' },
			];
		},
		bandiera,
		tipo(item) {
			return tipologia(item.type);
		},
		// per ogni lingua del profilo: compilata se ha oggetto e testo
		statoLingue(item) {
			const salvate = item.traduzioni || (item.trans ? [item.trans] : []);
			const lingue = _.uniq([...this.lingue, ...salvate.map(t => t.lang)]).filter(Boolean);
			return lingue.map(lang => {
				const t = _.find(salvate, { lang }) || {};
				return { lang, ok: !!(String(t.oggetto || '').trim() && testoPiano(t.text)) };
			});
		},
		aperto(item) {
			return this.aperti.includes(item._id);
		},
		apri(item) {
			this.aperti = this.aperto(item) ? this.aperti.filter(id => id !== item._id) : [...this.aperti, item._id];
		},
		notifica(color, text) {
			this.snackbar = { snackbar: true, color, timeout: 5000, text };
		},
		// inserimento e modifica sono pagine: la lista resta nel suo URL e ci si torna uguale
		editItem(item) {
			this.$router.push(`/ecommerce/emailtemplate/${item._id}`);
		},
		createItem() {
			this.$router.push('/ecommerce/emailtemplate/new');
		},
		getDataFromApi() {
			this.setPreload(true);
			return this.fetchItems(this.settings)
				.then(result => {
					this.total = result ? result.total : 0;
				})
				.catch(err => console.log(err))
				.finally(() => this.setPreload(false));
		},
		deleteItem(item) {
			this.daEliminare = item;
			this.dialogconfirm = true;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			if (!this.daEliminare) return;
			this.setPreload(true);
			this.delete(this.daEliminare)
				.then(data => {
					if (data && data.error) {
						this.notifica('error', 'Eliminazione non riuscita');
						return;
					}
					return this.getDataFromApi().then(() => this.notifica('success', 'Operazione effettuata con successo'));
				})
				.catch(error => console.log(error))
				.finally(() => {
					this.daEliminare = null;
					this.setPreload(false);
				});
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
};
</script>


<style scoped>
.et-flags {
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
}
.et-flags img {
	width: 20px;
	height: 14px;
	object-fit: cover;
	border-radius: 2px;
	box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}
.et-flags img.et-flag--off {
	filter: grayscale(1);
	opacity: 0.35;
}
.et-subject {
	max-width: 360px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.et-expanded,
.et-expanded:hover {
	background: transparent !important;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.emailtpl-cards,
.emailtpl-cards tr {
	display: block;
	width: 100%;
}
.emailtpl-cards tr,
.emailtpl-cards tr:hover {
	background: transparent !important;
}
.emailtpl-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.emailtpl-cards tr:first-child td {
	padding-top: 12px !important;
}
.emailtpl-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.emailtpl-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
